import { actions } from './actions'

const initialState = {
  data: [],
}

export default function topicsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_TOPICS_RESULT:
      return { ...state, data: action.payload.data }
    default:
      return state
  }
}
